import { handleActions } from '@mendeley-internal/lib-js-redux-actions';
import { getFollowing, followUser, unfollowUser } from '../actions/follow';
import { omit } from '../utils/object';

const initialState = {
  users: null,
  pendingUsers: {},
  fetching: false,
  error: null,
  timeout: false
};

export default handleActions({
  [getFollowing]: {
    first(state) {
      return { ...state, fetching: true };
    },
    next(state, { payload: { items } }) {
      return {
        ...state,
        fetching: false,
        users: items.reduce((users, { followedId, id: relationship }) => ({
          ...users,
          [followedId]: relationship
        }), state.users)
      };
    },
    throw(state, { payload: { response } }) {
      return {
        users: {},
        fetching: false,
        error: true,
        timeout: response && response.status === 504
      };
    }
  },
  [followUser]: {
    first(state, { meta: { userId } }) {
      return {
        ...state,
        pendingUsers: {
          ...state.pendingUsers,
          [userId]: null
        }
      };
    },
    next(state, { payload: { id }, meta: { userId } }) {
      return {
        ...state,
        users: {
          ...(state.users || {}),
          [userId]: id
        },
        pendingUsers: omit([userId], state.pendingUsers)
      };
    },
    throw(state, { meta: { userId } }) {
      return {
        ...state,
        pendingUsers: omit([userId], state.pendingUsers)
      };
    }
  },
  [unfollowUser]: {
    first(state, { meta: { userId } }) {
      return {
        ...state,
        users: omit([userId], state.users),
        pendingUsers: {
          ...state.pendingUsers,
          [userId]: state.users[userId]
        }
      };
    },
    next(state, { meta: { userId } }) {
      return {
        ...state,
        pendingUsers: omit([userId], state.pendingUsers)
      };
    },
    throw(state, { meta: { userId } }) {
      return {
        ...state,
        users: {
          ...state.users,
          [userId]: state.pendingUsers[userId]
        },
        pendingUsers: omit([userId], state.pendingUsers)
      };
    }
  }
}, initialState);



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/following.js